'use client'

import { Suspense, useState } from 'react'
import Image from 'next/image'
import { useQuery } from '@tanstack/react-query'
import Button from '@ui/ButtonNew/Button'
import { axiosProxy } from '@utils/axios'
import { getMailruAuthUrl, getTelegramAuthUrl, getVkAuthUrl } from '@view/auth/api'
import { observer } from 'mobx-react-lite'

import MailruIcon from '../../assets/social/mailru.svg'
import TelegramIcon from '../../assets/social/telegram.svg'
import VkIcon from '../../assets/social/vk.svg'
import styles from './page.module.scss'

const fetchAuthStatus = async (token: string) => {
  if (!token) return
  const { data: response } = await axiosProxy.get('/auth/telegram/check/' + token)
  return response.data
}

export const Oauth = observer(({ state }: { state: string }) => {
  const [token, setToken] = useState('')
  const [url, setUrl] = useState('')
  const [qr, setQr] = useState('')

  const timestamp = Date.now()

  const VK = async (state: string) => {
    try {
      const { data: response } = await getVkAuthUrl(state)
      if (response.data?.url) {
        window.location.href = response.data?.url
      }
    } catch {
      // captureException(error)
      // toast.error('Something went wrong')
    }
  }

  const MailRu = async (state: string) => {
    try {
      const { data: response } = await getMailruAuthUrl(state)
      if (response.data?.url) {
        window.location.href = response.data?.url
      }
    } catch {
      // captureException(error)
      // toast.error('Something went wrong')
    }
  }

  const Telegram = async () => {
    try {
      const { data: response } = await getTelegramAuthUrl()
      // console.log(response.data)
      if (response.data?.token) {
        setUrl(response.data?.url)
        setQr(response.data?.qr)
        setToken(response.data?.token)
      }
    } catch {
      // captureException(error)
      // toast.error('Something went wrong')
    }
  }

  const iconSize = 21

  const { data: reponse } = useQuery({
    queryKey: ['telegram_auth_check', token],
    enabled: !!token,
    queryFn: () => fetchAuthStatus(token),
    refetchOnWindowFocus: true,
    refetchInterval: 3000,
    refetchIntervalInBackground: true,
  })

  if (reponse?.confirmed) {
    window.location.href = '/my'
  }

  if (token) {
    return (
      <Suspense>
        <div className="mt-8 mb-4">
          <div className="flex items-start gap-4">
            <div className="w-[150px]">
              <img src={qr + `?nc=${timestamp}`} alt={'Привязка Telegram по QR-коду'} width={150} height={150} />
            </div>
            <div className="max-w-2xl flex-1 text-sm text-gray-500 text-left">
              Перейдите в диалог с чат-ботом <b>@EvirmaBot</b> с помощью QR-кода или кнопку ниже. В окне чата{' '}
              <b>нажмите&nbsp;Start</b> и следуйте инструкциям.
              {url ? (
                <Button view="success" target="_blank" href={url} className="mt-6 text-sm">
                  Перейти в чат-бот
                </Button>
              ) : (
                ''
              )}
            </div>
          </div>
        </div>

        <div className={styles.divider}>или</div>
      </Suspense>
    )
  }

  return (
    <Suspense>
      <div className="mt-4 mb-4">
        <Button view="default" fullWidth={true} onClick={() => MailRu(state)}>
          <Image
            priority
            src={MailruIcon}
            width={iconSize}
            height={iconSize}
            className="mr-2"
            alt="Войти через Mail.Ru"
          />
          Войти через&nbsp;<span className="font-medium font-lg">Mail.RU</span>
        </Button>
      </div>

      <div className="mt-4 mb-4">
        <Button view="default" fullWidth={true} onClick={() => VK(state)}>
          <Image priority src={VkIcon} width={iconSize} height={iconSize} className="mr-2" alt="Войти через VK" />
          Войти через&nbsp;<span className="font-medium font-lg">VK</span>
        </Button>
      </div>

      {!state && (
        <div className="mt-4 mb-4">
          <Button view="default" fullWidth={true} onClick={() => Telegram()}>
            <Image
              priority
              src={TelegramIcon}
              width={iconSize}
              height={iconSize}
              className="mr-2"
              alt="Войти через Telegram"
            />
            Войти через&nbsp;<span className="font-medium font-lg">Telegram</span>
          </Button>
        </div>
      )}

      <div className={styles.divider}>или</div>
    </Suspense>
  )
})
